import { business } from '../data/siteData'
import './MapEmbed.css'

export default function MapEmbed() {
  return (
    <div className="map-embed">
      <iframe
        title="AS Elite Gatherings location"
        src={business.mapsQuery}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  )
}
